// extracted by mini-css-extract-plugin
module.exports = {"heroHeader":"sortiment_heroHeader__0gSgI","item":"sortiment_item__xjqOV"};